<template>
  <div :class="b('', { isActive })">
    <c-main-navigation-icon-button @click="toggleActiveState">
      <e-icon
        icon="i-user"
        size="22"
      />
    </c-main-navigation-icon-button>

    <div
      v-if="$viewport.isMd"
      :class="b('dropdown')"
    >
      <c-user-navigation-menu variant="desktop" />
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import cMainNavigationIconButton from '@/components/c-main-navigation-icon-button.vue';
  import cUserNavigationMenu from '@/components/c-user-navigation-menu.vue';
  import eIcon from '@/elements/e-icon.vue';

  // type Setup = {};
  type Data = {
    isActive: boolean;
  };

  /**
   * Renders the user navigation with its main menu icon.
   */
  export default defineComponent({
    name: 'c-user-navigation',
    components: {
      cUserNavigationMenu,
      cMainNavigationIconButton,
      eIcon,
    },

    emits: {
      onButtonClick: Boolean,
    },

    // props: {},
    // emits: [],

    // setup(): Setup {
    //   return {};
    // },
    data(): Data {
      return {
        isActive: false,
      };
    },

    // computed: {},
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    methods: {
      toggleActiveState(): void {
        this.isActive = !this.isActive;
        this.$emit('onButtonClick', this.isActive);
      },
    },
    // render() {},
  });
</script>

<style lang="scss">
  @use '@/setup/scss/mixins';
  @use '@/setup/scss/variables';

  .c-user-navigation {
    $this: &;

    position: relative;

    &:hover {
      background: var(--theme-color-grayscale--200);

      #{$this}__dropdown {
        display: flex;
      }
    }

    &--is-active {
      @include mixins.media($down: sm) {
        background: var(--theme-color-grayscale--200);
      }
    }

    &__dropdown {
      display: none;
      position: absolute;
      top: 100%;
      left: 0;
      background: var(--theme-color-grayscale--900);
      box-shadow: 0 5px 15px rgba(var(--theme-color-grayscale--200-rgb), 0.9);
      min-width: 12rem;
      z-index: 101;
    }
  }
</style>
